import React from 'react';
import { withTranslation } from 'react-i18next';
import { Field, FieldArray } from 'redux-form';
import PropTypes from 'prop-types';
import { Col, FormWrapper, InlineFormRow, RFFormInput } from 'virtues-bootstrap';

import PhonesFieldArray from '../Phones';

const AdditionalForm = ({ namePrefix, title, t }) => (
  <FormWrapper title={title}>
    <InlineFormRow label={t('addPatient.firstName')} labelRequired>
      <Col xs={7}>
        <Field component={RFFormInput} name={`${namePrefix}FirstName`} placeholder="Paul" />
      </Col>
    </InlineFormRow>
    <InlineFormRow label={t('addPatient.lastName')} labelRequired>
      <Col xs={7}>
        <Field component={RFFormInput} name={`${namePrefix}LastName`} placeholder="Smith" />
      </Col>
    </InlineFormRow>
    <InlineFormRow label={t('addPatient.phoneNumber')} labelRequired>
      <FieldArray name={`${namePrefix}Phone`} component={PhonesFieldArray} />
    </InlineFormRow>
  </FormWrapper>
);

AdditionalForm.propTypes = {
  namePrefix: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default withTranslation()(AdditionalForm);
